import Upload from '@common/Upload'
import { getImageAutoOrientLink, getImageSizeByFile } from '@util'
import { message } from 'hljd'
import { inject } from 'mobx-react'
import React, { Component } from 'react'
import styles from './style.module.less'

@inject('centerStore')
class UploadCom extends Component {
  onOk = (file, link) => {
    const { onChange } = this.props
    onChange && onChange(link)
  }
  onDel = () => {
    const { onChange } = this.props
    onChange && onChange('')
  }
  onBeforeUp = async file => {
    const { limitHeight, limitWidth } = this.props
    const { width, height } = await getImageSizeByFile(file.getNative())
    if (width < limitWidth || height < limitHeight) {
      message.error(`图片尺寸太小，请重新上传`)
      return Promise.reject()
    }
    return Promise.resolve()
  }
  onCliped = (value, info) => {
    const { limitHeight, limitWidth } = this.props
    const { width, height } = value.pixel
    if (width < limitWidth || height < limitHeight) {
      return message.error(
        `图片宽度需大于${limitWidth}，高度需大于${limitHeight}`
      )
    }
    if (value && value.clipUrl) {
      value.clipUrl = getImageAutoOrientLink(value.clipUrl)
    }
    const { onChange } = this.props
    onChange && onChange(value)
    this.props.centerStore.checkImg.checkCMYK(1, value.data)
  }

  onError = e => {
    message.error('图片大小超出限制')
  }

  render() {
    const { value, aspect } = this.props
    return (
      <Upload
        height={120}
        width={194}
        max_file_size="10mb"
        clipabled
        aspect={aspect ? aspect : 400 / 300}
        onOk={this.checkColorMode}
        onError={this.onError}
        showDelete
        onDelete={this.onDel}
        link={value?.clipUrl ?? ''}
        onCliped={this.onCliped}
        onBeforeUp={this.onBeforeUp}
        target="_self"
        // eslint-disable-next-line no-undef
        javaUpTokenUrl={`${__JAVA__DOMAIN__}/hms/mediacenter/appApi/media/app/token?from=MerchantImage`}
        description={
          <div className={styles['upload_des']}>
            <div className={styles['upload_add']}>+</div>
            <p>横图</p>
            <p>1080*675px</p>
          </div>
        }
        autoSuffix={false}
        filters={{
          mime_types: [
            { title: 'Image files', extensions: 'jpg,png,jpeg,bmp' }
          ],
          max_file_size: '10mb'
        }}
        noUploadMark
      />
    )
  }
}

export default UploadCom
